import { useCallback, useState } from "react";
import { useParams } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Card, CardContent } from "@/components/ui/card";
import { Loader2 } from "lucide-react";
import { getSharedRevisionRespuesta, replySharedRevisionViaPassword } from "@/lib/api";
import { toast } from "sonner";
import RevisionPublicSheet from "@/components/RevisionPublicSheet";

export default function RevisionRespuestaCompartidaPage() {
  const { shareId } = useParams();
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [data, setData] = useState(null);

  const loadData = useCallback(async () => {
    if (!shareId || !password.trim()) return;
    setLoading(true);
    setError("");
    try {
      const res = await getSharedRevisionRespuesta(shareId, password.trim());
      setData(res);
    } catch (err) {
      const msg = err.response?.data?.detail || "Contraseña incorrecta o enlace no válido";
      setError(msg);
      toast.error(msg);
      setData(null);
    } finally {
      setLoading(false);
    }
  }, [shareId, password]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!shareId || !password.trim() || loading) return;
    await loadData();
  };

  if (!shareId) {
    return (
      <div className="min-h-dvh flex items-center justify-center bg-background px-4">
        <p className="text-sm text-muted-foreground">Enlace no válido.</p>
      </div>
    );
  }

  if (!data) {
    return (
      <div className="min-h-dvh flex items-center justify-center bg-background px-4">
        <div className="w-full max-w-md">
          <Card>
            <CardContent className="pt-6 space-y-4">
              <h1 className="text-xl font-semibold text-center">Hoja de trabajo compartida</h1>
              <p className="text-sm text-muted-foreground text-center">
                Introduce la contraseña para ver la ficha completa, las revisiones y las respuestas del cliente.
              </p>
              <form onSubmit={handleSubmit} className="space-y-3">
                <Input
                  type="password"
                  autoComplete="off"
                  placeholder="Contraseña"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
                {error && <p className="text-xs text-destructive text-center">{error}</p>}
                <Button type="submit" className="w-full gap-2" disabled={loading || !password.trim()}>
                  {loading && <Loader2 className="w-4 h-4 animate-spin" aria-hidden />}
                  Ver ficha
                </Button>
              </form>
            </CardContent>
          </Card>
        </div>
      </div>
    );
  }

  return (
    <RevisionPublicSheet
      data={data}
      initialLoading={false}
      onReload={loadData}
      submitReply={(payload) => replySharedRevisionViaPassword(shareId, password.trim(), payload)}
    />
  );
}
